import { baseApi } from 'api/baseApi';
import objectEditorReducer from 'pages/objectManager/slices/objectEditor.slice';
import { combineReducers } from 'redux';
import aopUserConfigReducer from '../microFrontend/slices/aopUserConfig.slice';
import apiKeysReducer from './apiKeys.slice';
import appServiceReducer from './appService.slice';
import appsAllocateSettingsSlice from './appsAllocateSettings';
import appsIntegrationSettingsReducer from './appsIntegrationSettings.slice';
import appsPrefGeneralSettingsSlice from './appsPrefGeneralSettings';
import appsPrefReviewSettingsSlice from './appsPrefReviewSettings';
import prefWeekNamesSlice from './appsPrefWeekNames';
import appsReportSourceTypeSlice from './appsReportSourceType';
import assignablePermissionReducer from './assignablePermission.slice';
import authReducer from './auth.slice';
import authConfigReducer from './authConfig.slice';
import authenticationTokenReducer from './authenticationToken.slice';
import availabilityCollectionPeriodReducer from './availabilityCollectionPeriod.slice';
import availabilityCollectionSettingsReducer from './availabilityCollectionSettings.slice';
import availabilityCollectionTimeslotReducer from './availabilityCollectionTimeslot.slice';
import availabilityTypeReducer from './availabilityRelation.slice';
import dynamicAvailabilityReducer from './dynamicAvailability.slice';
import emailPreferencesReducer from './emailPreferences.slice';
import examInCoreReducer from './examInCoreSettings.slice';
import examV3ExamReservationSettingsReducer from './examV3ExamReservationSettings.slice';
import examV3ExportTemplatesReducer from './examV3ExportTemplates.slice';
import examV3SettingsReducer from './examV3Settings.slice';
import fieldReducer from './field.slice';
import fieldRelationReducer from './fieldRelation.slice';
import holidayReservationReducer from './holidayReservation.slice';
import hubDashboardReducer from './hubDashboard.slice';
import hubFeaturesReducer from './hubFeatures.slice';
import hubStudentSettingsReducer from './hubStudentSettings.slice';
import importsReducer from './import.slice';
import languagesReducer from './language.slice';
import logsReducer from './logs.slice';
import maintenanceReducer from './maintenance.slice';
import membershipsReducer from './memberships.slice';
import objectGenerationTemplateReducer from './objectGenerationTemplate.slice';
import objectRelationshipReducer from './objectRelationships.slice';
import objectTypesSlice from './objectTypes.slice';
import organizationReducer from './organization.slice';
import organizationHierarchyReducer from './organizationHierarchy.slice';
import paddingRulesReducer from './paddingRules.slice';
import periodReducer from './period.slice';
import permissionReducer from './permission.slice';
import persistedColumnsSlice from './persistedColumns.slice';
import persistedFiltersSlice from './persistedFilters.slice';
import relationTypeReducer from './relationType.slice';
import reportTemplateReducer from './reportTemplate.slice';
import reportingLogsReducer from './reportingLogs.slice';
import reservationModeReducer from './reservationMode.slice';
import reservationSettingReducer from './reservationSettings.slice';
import reservationTemplateReducer from './reservationTemplate.slice';
import rolePermissionsReducer from './rolePermission.slice';
import rolesReducer from './roles.slice';
import studyCombinationsReducer from './studyCombinations.slice';
import suppportInfoReducer from './supportInfo.slice';
import systemActionsReducer from './systemActions.slice';
import systemPreferencesReducer from './systemPreferences.slice';
import timeRuleReducer from './timeRule.slice';
import timeZonesReducer from './timeZone.slice';
import uiReducer from './ui.slice';
import userReducer from './user.slice';
import viewerPagesReducer from './viewerPages.slice';

const rootReducer = combineReducers({
  // RTK Query base API slice
  [baseApi.reducerPath]: baseApi.reducer,
  apiKeys: apiKeysReducer,
  appService: appServiceReducer,
  appsIntegrationSettings: appsIntegrationSettingsReducer,
  appsPrefReviewSettings: appsPrefReviewSettingsSlice,
  appsPrefGeneralSettings: appsPrefGeneralSettingsSlice,
  appsAllocateSettings: appsAllocateSettingsSlice,
  appsReportSourceType: appsReportSourceTypeSlice,
  assignablePermissions: assignablePermissionReducer,
  auth: authReducer,
  authConfigs: authConfigReducer,
  authenticationTokens: authenticationTokenReducer,
  availabilityTypes: availabilityTypeReducer,
  dynamicAvailability: dynamicAvailabilityReducer,
  emailPreferences: emailPreferencesReducer,
  examInCoreSettings: examInCoreReducer,
  examV3Settings: examV3SettingsReducer,
  examV3ExportTemplates: examV3ExportTemplatesReducer,
  examV3ExamReservationSettings: examV3ExamReservationSettingsReducer,
  hubStudentSettings: hubStudentSettingsReducer,
  fields: fieldReducer,
  fieldRelations: fieldRelationReducer,
  persistedColumns: persistedColumnsSlice,
  persistedFilters: persistedFiltersSlice,
  holidayReservations: holidayReservationReducer,
  imports: importsReducer,
  languages: languagesReducer,
  logs: logsReducer,
  maintenance: maintenanceReducer,
  memberships: membershipsReducer,
  objectRelationships: objectRelationshipReducer,
  objectEditor: objectEditorReducer,
  objectTypes: objectTypesSlice,
  organizations: organizationReducer,
  organizationHierarchy: organizationHierarchyReducer,
  paddingRules: paddingRulesReducer,
  periods: periodReducer,
  permissions: permissionReducer,
  prefWeekNames: prefWeekNamesSlice,
  relationTypes: relationTypeReducer,
  reportTemplate: reportTemplateReducer,
  reportingLogs: reportingLogsReducer,
  reservationModes: reservationModeReducer,
  reservationSettings: reservationSettingReducer,
  reservationTemplates: reservationTemplateReducer,
  rolePermissions: rolePermissionsReducer,
  roles: rolesReducer,
  supportInfo: suppportInfoReducer,
  systemActions: systemActionsReducer,
  systemPreferences: systemPreferencesReducer,
  timeRules: timeRuleReducer,
  timeZones: timeZonesReducer,
  ui: uiReducer,
  users: userReducer,
  viewerPages: viewerPagesReducer,
  studyCombinations: studyCombinationsReducer,
  availabilityCollectionSettings: availabilityCollectionSettingsReducer,
  availabilityCollectionTimeslots: availabilityCollectionTimeslotReducer,
  availabilityCollectionPeriod: availabilityCollectionPeriodReducer,
  hubDashboard: hubDashboardReducer,
  hubFeatures: hubFeaturesReducer,
  objectGenerationTemplate: objectGenerationTemplateReducer,
  aopUserConfig: aopUserConfigReducer,
});

export default rootReducer;
